import tw, { styled } from 'twin.macro';

const Heading1 = styled.h1`
  ${tw`text-3xl sm:text-4xl md:text-5xl font-bold mb-5 relative z-10`};
  ${tw`print:!text-lg`}
  line-height: 1.3;
`;

export default Heading1;
